import React, { useCallback, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import StripeCheckout from "../User/Cart/StripeCheckout";
import { connect } from "react-redux";
import { toggleSignUp, getUserDetails } from "../../store/actions/user/User";
import { getVendorDetails } from "../../store/actions/vendor/Vendor";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import SignIn from "./SignIn";

const useStyles = makeStyles((theme) => ({
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: "2%",
    marginBottom: "2%",
    backgroundColor:'var(--white)',
    [theme.breakpoints.down('sm')]:{
      padding: "2%",
    }    
  },
  cardInput:{
    minWidth:'300px',
    [theme.breakpoints.down('sm')]:{
      minWidth: "200px",
    } 
  }
}));

function PaymentCard(props) {
  const classes = useStyles();

  const [paymentOption, setpaymentOption] = useState(null);
  const [showPaymentGateway, setshowPaymentGateway] = useState(false);
  const [authUser,setAuthUser] = useState(localStorage.getItem('userLoginType'))
  const { price } = props;
  const handlePaymentOptionChange = (event) => {
    setpaymentOption(event.target.value);
  };

  const proceedToPayment = (data) => {
    if (props.onSuccess) {
      props.onSuccess(data);
    }
  };

  const handleProceedToPay = () => {
    if (paymentOption === "wallet") {
      proceedToPayment({ id: "NOT_REQUIRED" });
    } else {
      setshowPaymentGateway(true);
    }
  };
  const renderPaymentCondition = () => {
    const { vendorDetail } = props;
    if (
      !showPaymentGateway &&
      vendorDetail && vendorDetail.walletAmount &&
      vendorDetail.walletAmount >= price
    ) {
      return (
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="paymentOption"
            name="paymentOption"
            value={paymentOption}
            onChange={handlePaymentOptionChange}
          >
            <FormControlLabel
              value="wallet"
              control={<Radio />}
              label={`Use Wallet Balance (Wallet Balance ${vendorDetail.walletAmount})`}
            />
            <FormControlLabel
              value="card"
              control={<Radio />}
              label="Pay By Card"
            />
          </RadioGroup>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <button
              className="site-btn btnAdd submit-order-btn"
              style={{
                color: !paymentOption ? "black" : "white",
                background: !paymentOption ? "#ffffff" : "rgb(1, 160, 90)",
              }}
              disabled={!paymentOption}
              onClick={handleProceedToPay}
            >
              Proceed To Pay
            </button>
          </div>
        </FormControl>
      );
    } else if (
      !showPaymentGateway &&
      vendorDetail && vendorDetail.walletAmount &&
      vendorDetail.walletAmount < price
    ) {
      return (
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="paymentOption"
            name="paymentOption"
            value={paymentOption}
            onChange={handlePaymentOptionChange}
          >
            <FormControlLabel
              value="rechargeWallet"
              control={<Radio />}
              label={`Recharge Wallet and Pay (Wallet Balance ${vendorDetail.walletAmount})`}
            />
            <FormControlLabel
              value="card"
              control={<Radio />}
              label="Pay By Card"
            />
          </RadioGroup>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <button
              className="site-btn btnAdd submit-order-btn"
              style={{
                color: !paymentOption ? "black" : "white",
                background: !paymentOption ? "#ffffff" : "rgb(1, 160, 90)",
              }}
              disabled={!paymentOption}
              onClick={handleProceedToPay}
            >
              Proceed To Pay
            </button>
          </div>
        </FormControl>
      );
    } else {
      return <StripeCheckout handlePayment={proceedToPayment} />;
    }
  };

  let component = props.auth ? <>{renderPaymentCondition()}</> : <SignIn />;

  return (
    <>
      <Typography
      variant="h6"
      style={{ color: "var(--darker)", textAlign:'left',textTransform:'capitalize',marginBottom:'10px' }}
    > Payment</Typography>
      <Grid item xs="12">
        <Paper className={classes.control} elevation={0}>
          <Grid container spacing={0}>
            {component}
          </Grid>
        </Paper>
      </Grid>
    </>
  );
}

const mapStateWithProps = (state) => ({
  auth: state.user.auth,
  userDetails: state.user.userDetails,
  vendorDetail: state.vendor.vendorDetail,
});

const mapDispatchToProps = (dispatch) => ({
  getUserDetails: () => dispatch(getUserDetails()),
  getVendorDetails: () => dispatch(getVendorDetails()),
});

export default connect(mapStateWithProps, mapDispatchToProps)(PaymentCard);
